import { object, string } from 'yup';
import { TP, urlRegex, VIDEO_ATTRIBUTE_TYPES_IDS } from '../../../../constants/consts';

export const commonDigitalEventFields = {
  isLiveEventConnected: {
    name: 'isLiveEventConnected',
    label: `${TP}.FN_PART_OF_LIVE_EVENT`,
  },
  performanceDate: {
    name: 'performanceDate',
    label: `${TP}.PERFORMANCE_LIVE_EVENT`,
  },
  costType: {
    name: 'costType',
    label: `${TP}.FN_VIDEO_COST_TYPE`,
  },
  thumbnail: {
    name: 'thumbnail',
  },
};

export const VODCardFields = {
  ...commonDigitalEventFields,
  url: {
    name: 'url',
    label: `${TP}.FN_VIDEO_ON_DEMAND_URL`,
  },
  // endTime: {
  //   name: 'endTime',
  //   label: `${TP}.FN_TIME`,
  //   typeId: VIDEO_ATTRIBUTE_TYPES_IDS.END_TIME,
  // },
  dateFrom: {
    name: 'date_from',
    label: `${TP}.m_FROM`,
    typeId: VIDEO_ATTRIBUTE_TYPES_IDS.START_DATE,
  },
  dateTo: {
    name: 'date_to',
    label: `${TP}.m_TO`,
    typeId: VIDEO_ATTRIBUTE_TYPES_IDS.END_DATE,
  },
};

export const livestreamCardFields = {
  ...commonDigitalEventFields,
  url: {
    name: 'url',
    label: `${TP}.FN_LIVESTREAM_URL`,
  },
  startTime: {
    name: 'livestreamTime',
    label: `${TP}.FN_TIME`,
    typeId: VIDEO_ATTRIBUTE_TYPES_IDS.START_TIME,
  },
  dateFrom: {
    name: 'livestreamDate',
    label: `${TP}.m_DATE`,
    typeId: VIDEO_ATTRIBUTE_TYPES_IDS.START_DATE,
  },
  timezone: {
    name: 'timezone',
    label: `${TP}.REGISTRATION_TIME_ZONE`,
    typeId: VIDEO_ATTRIBUTE_TYPES_IDS.TIMEZONE,
  },
};

export const livestreamValidationSchema = object().shape({
  [livestreamCardFields.dateFrom?.name]: string().required(`${TP}.FN_REQUIRED_FIELD`),
  [livestreamCardFields.url?.name]: string()
    .matches(urlRegex, `${TP}.FN_WEB_LINK_INVALID`)
    .required(`${TP}.FN_REQUIRED_FIELD`),
  [livestreamCardFields.startTime?.name]: string().required(`${TP}.FN_REQUIRED_FIELD`),
  [livestreamCardFields.timezone?.name]: object()
    .required(`${TP}.FN_REQUIRED_FIELD`)
    .nullable(),
});

export const VODValidationSchema = object().shape({
  [VODCardFields.url?.name]: string()
    .matches(urlRegex, `${TP}.FN_WEB_LINK_INVALID`)
    .required(`${TP}.FN_REQUIRED_FIELD`),
});
